import serviceIcon from "@/assets/images/services/features/sap/service.svg";
import solutionIcon from "@/assets/images/services/features/sap/support.svg";
import supportIcon from "@/assets/images/services/features/sap/support.svg";

import zohoAboutImage from "@/assets/images/services/about/zoho-creator-about-image.png";

const zohoCreator = {
  "zoho-creator": {
    slug: "zoho-creator",
    name: "Zoho Creator",
    hero: {
      title:
        "Build Custom Business Applications with GSUS Star Software — Official Zoho Creator Partner in India",
      description:
        "Low-Code Solutions for Fast, Flexible, and Scalable Business Apps At GSUS Star Software, we’re proud to be an official Zoho Creator Partner. Our mission is simple — to help businesses design, develop, and deploy custom applications that automate processes, save time, and increase efficiency, all without the complexity of traditional coding."
    },

    features: [
      {
        icon: serviceIcon,
        title: " Low-Code Development",
        description:
          "Build apps up to 10x faster with Zoho Creator’s powerful low-code platform."
      },
      {
        icon: solutionIcon,
        title: " Fully Customized Solutions",
        description:
          "Whether it’s inventory management, CRM, HR automation, or project tracking — we tailor apps to match your exact business needs."
      },
      {
        icon: supportIcon,
        title: "Seamless Integration",
        description:
          "Connect your apps with Zoho One, Zoho Books, Zoho CRM, ERP software, or third-party tools like Google Workspace, Microsoft 365, and payment gateways."
      }
    ],

    about: {
      subtitle: "Industries We Serve",
      heading: "Powering Businesses Across Industries",
      image: zohoAboutImage,
      highlights: [
        "Retail & E-Commerce",
        "Manufacturing & Supply Chain",
        "Healthcare & Clinics",
        "Construction & Real Estate",
        "Education & Training",
        "Service-Based Businesses"
      ]
    },

    // services: {
    //   title: "Transform Your Business with AI-Driven Innovation",
    //   description:
    //     "Empower your business with cutting-edge AI solutions that drive efficiency, automation, and intelligent decision-making. From data analytics to natural language processing, our technologies unlock new opportunities for growth and smarter operations.",
    //   items: [
    //     {
    //       image: dataAnalyticsImage,
    //       name: "AI-Powered Data Analytics",
    //       description:
    //         "Transform your data into actionable insights with our AI-powered analytics solutions. We help you make informed decisions that drive business growth.",
    //       features: [
    //         "Advanced data mining techniques",
    //         "Customized reporting dashboards",
    //         "Real-time data processing",
    //         "Predictive analytics for future trends"
    //       ]
    //     },
    //     {
    //       image: automationImage,
    //       name: "Intelligent Automation",
    //       description:
    //         "Boost productivity and reduce operational costs with our AI-driven automation solutions. We streamline your workflows for maximum efficiency.",
    //       features: [
    //         "Process automation for routine tasks",
    //         "Custom workflows and automation",
    //         "AI-powered decision-making tools",
    //         "Integration with existing systems"
    //       ]
    //     },
    //     {
    //       image: NLPImage,
    //       name: "Natural Language Processing (NLP)",
    //       description:
    //         "Enhance customer experiences with our NLP solutions. We enable seamless communication between humans and machines, improving user interaction and support.",
    //       features: [
    //         "Chatbot development",
    //         "Sentiment analysis",
    //         "Language translation",
    //         "Speech recognition and processing"
    //       ]
    //     }
    //   ]
    // },

    processKpi: {
      heading: "Our Zoho Creator Development Process",
      steps: [
        {
          number: "01",
          title: "Discovery",
          description: "We understand your workflows, challenges, and goals."
        },
        {
          number: "02",
          title: "Design",
          description:
            "We map your process into an intuitive, easy-to-use app design."
        },
        {
          number: "03",
          title: "Development",
          description: "Our certified team builds and tests your app."
        },
        {
          number: "04",
          title: "Deployment",
          description: "Launch your app and train your team for success."
        },
        {
          number: "05",
          title: "Ongoing Support",
          description:
            "We maintain, upgrade, and scale your app as your business grows."
        }
      ]
    },

    expertise: {
      heading: "Why Businesses Trust GSUS Star Software",
      business: [
        {
          description: "Certified Zoho Creator Partner in India"
        },
        {
          description: "Proven track record of delivering scalable solutions"
        },
        {
          description: "Dedicated support & training"
        },
        {
          description: "Fast delivery without compromising quality"
        },
        {
          description: "10+ years of experience in custom software development"
        }
      ]
    },
    cta: {
      title: "Get Started Today?",
      description:
        "Transform your business with a custom-built Zoho Creator application.",
      button: "Book your free consultation now!"
    },

    faq: {
      items: [
        {
          question: "What is Zoho Creator?",
          answer:
            "Zoho Creator is a low-code application development platform that allows businesses to build custom apps quickly without needing advanced coding skills."
        },
        {
          question: "Why should I choose GSUS Star Software as my Zoho Creator Partner?",
          answer: "As a certified Zoho Creator Partner in India, GSUS Star Software combines 10+ years of software development expertise with Zoho’s powerful platform. We ensure your app is designed to match your exact business needs, integrated seamlessly, and supported end-to-end"
        },
        {
          question: "What kind of apps can be built with Zoho Creator?",
          answer:
            "Inventory & Order Management,CRM & Sales Automation,HR & Payroll,Field Service Management,Customer & Vendor Portals"
        },
        {
          question: "Can Zoho Creator apps integrate with other software?",
          answer:
            "Yes! Zoho Creator apps can integrate with Zoho applications (CRM, Books, Zoho One) as well as third-party platforms like Google Workspace, Microsoft 365, QuickBooks, payment gateways, and ERP systems."
        },
        {
          question: "Is Zoho Creator secure for business data?",
          answer:
            "Absolutely. Zoho Creator provides enterprise-grade security with data encryption, multi-factor authentication, and role-based access controls to keep your business data safe."
        },
        {
          question: "How long does it take to build an app with Zoho Creator?",
          answer:
            "Unlike traditional development, Zoho Creator apps can be built in days or weeks instead of months — depending on your requirements."
        },
        {
          question: "What is the cost of Zoho Creator app development?",
          answer:
            "The cost depends on your app’s complexity and features. At GSUS Star Software, we provide affordable packages tailored to small and mid-sized businesses. Contact us for a free consultation."
        },
        {
          question: "Will you provide support after the app is built?",
          answer:
            "Yes. We offer training, maintenance, and ongoing support to ensure your app continues to run smoothly and evolves with your business."
        }
      ]
    }
  }
};
export default zohoCreator;
